/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: IBalance.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.11.22 1:56 pm.
 * Last modified: 08.11.22 1:56 pm.
 *
 * More information at: https://egt-digital.com/
 */

import IExternalBalance from './IExternalBalance';

interface IBalance extends IExternalBalance {
    formattedBalance: string;
}

export const defaultBalance: IBalance = {
    units: 100,
    currency: 'EGT',
    balance: 50000,
    formattedBalance: '500.00',
};

export default IBalance;
